import { Page } from "modules/Page";

export class TrustCenterPage extends Page<typeof TrustCenterPage> {
    public static readonly className = "js-trust-center-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.addAnchorLinks();
        this.wrapAccordions();
    }

    public addAnchorLinks(): void {
        const anchorLinks = this.rootElement.querySelector(".anchor-links");
        const categories = this.rootElement.querySelectorAll(".subcategory-download-block h2");
        const html = document.querySelector("html");

        if (html) {
            html.classList.add("html-scroll__smooth");
        }

        categories.forEach((category) => {
           
            const listItem = document.createElement("li");
            const anchorLink = document.createElement("a");

            anchorLink.innerText = category.innerHTML;
            anchorLink.setAttribute("href", "#" + category.innerHTML);

            listItem.appendChild(anchorLink);

            if (anchorLinks) {
                anchorLinks.appendChild(listItem);
            }

        });

    }

    public wrapAccordions(): void {
        const blocks = this.rootElement.querySelectorAll(".accordion-block");

        blocks.forEach((block) => {            
            const wrapper = document.createElement("div");
            wrapper.classList.add("accordion-block__dark");

            if (block.parentNode !== null) {
                block.parentNode.insertBefore(wrapper, block);
                wrapper.appendChild(block);
            }            
        });       

    }
}